import { accountDetails } from "@di";
import LedgerReportRepository from "@adapters/repositories/Reports/LedgerReport";
import { downloadReportsRepo } from "@frameworks/web/components/Reports/understandingCommonDI/downloadReportsDI";
export default (http) => {
    return {
        ledger: new LedgerReportRepository(http, accountDetails),
        download: downloadReportsRepo,
    };
};
